
import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import AgeVerification, { AGE_VERIFIED_KEY } from './components/feature/AgeVerification';

function App() {
  const [verified, setVerified] = useState<boolean>(() => {
    return sessionStorage.getItem(AGE_VERIFIED_KEY) === 'true';
  });

  useEffect(() => {
    if (sessionStorage.getItem(AGE_VERIFIED_KEY) === 'true') {
      setVerified(true);
    }
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      {!verified && (
        <AgeVerification onVerified={() => setVerified(true)} />
      )}
      <div style={{ visibility: verified ? 'visible' : 'hidden' }}>
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
